import type { ScimGroup } from 'js-sdk/src/services/Admin/utils/types';
import TCClient from 'client';
import { sdkApi } from 'redux-stores/api';

const scimAPI = sdkApi.injectEndpoints({
  endpoints: (build) => ({
    getScimGroups: build.query<ScimGroup[], { groupIds: string[]; organizationId: string }>({
      queryFn: async ({ groupIds, organizationId }, _queryApi) => {
        const groups = await Promise.allSettled<ScimGroup>(
          groupIds.map(async (groupId) => {
            const group = await TCClient.scim.findScimGroup(groupId, organizationId);
            return group;
          })
        );
        const failed = groups.filter((group) => group.status === 'rejected');
        const successful = [];
        for (const group of groups) {
          if (group.status === 'fulfilled') {
            successful.push(group.value);
          }
        }
        if (failed.length > 0) {
          console.error('Failed to fetch some SCIM groups', failed);
        }
        return { data: successful };
      },
    }),
  }),
});

export const { useGetScimGroupsQuery } = scimAPI;
